export const DEFAULT_TEAM_SQUAD_DATA_ELEMENTS = ['age', 'matches_played', 'goals', 'assists', 'yellow_cards', 'red_cards'];

export const FULL_TEAM_SQUAD_DATA_ELEMENTS = [
  'age',
  'matches_played',
  'goals',
  'assists',
  'yellow_cards',
  'red_cards',
  'conceded',
  'cleansheets',
  'minutes_substitute',
  'minutes',
  'started',
];
